import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { InvestigationTypeRepository } from '../../../infrastructure/repositories/investigation-type.repository';
import { InvestigationTypeState } from '../../states/investigation-type.state';
import { InvestigationTypeDeletionImpactEntity } from '../../../domain/entities/investigation-type-deletion-impact.entity';

/**
 * Use case for retrieving investigation type deletion impact.
 * Checks dependencies before allowing investigation type deletion.
 */
@Injectable({ providedIn: 'root' })
export class GetInvestigationTypeDeletionImpactUseCase {
  private readonly repository = inject(InvestigationTypeRepository);
  private readonly state = inject(InvestigationTypeState);

  /**
   * Executes the use case to get investigation type deletion impact.
   * @param investigationTypeId - The investigation type ID to check
   * @returns Observable with deletion impact details
   */
  public execute(investigationTypeId: string): Observable<InvestigationTypeDeletionImpactEntity> {
    this.state.setLoadingInvestigationTypeDeletionImpact(true);
    this.state.setErrorInvestigationTypeDeletionImpact(null);

    return this.repository.getInvestigationTypeDeletionImpact(investigationTypeId).pipe(
      tap((impact) => {
        this.state.setInvestigationTypeDeletionImpact(impact);
        this.state.setLoadingInvestigationTypeDeletionImpact(false);
      }),
      catchError((error) => {
        const errorMessage = error?.error?.message || error?.message || 'Failed to load deletion impact';
        this.state.setErrorInvestigationTypeDeletionImpact(errorMessage);
        this.state.setLoadingInvestigationTypeDeletionImpact(false);
        throw error;
      })
    );
  }
}
